import React from 'react';
import AdSlot from 'components/ads/ad-slot';
import MainLayout from './main-layout.base';
import HeaderMobile from '../header/header.mobile';
import FooterMobile from '../footer/footer.mobile';
import { SLOT_SPONSORING_TOP, SLOT_SCROLLER } from 'components/ads/ad-slot/ad-defs';
import { Head } from '@ecommerce/nest-ssr/components';
import Container from 'atomic/container';
import AdSlotSSR from 'components/ads/ad-slot-ssr';

import './main-layout.mobile.scss';

type MainLayoutMobileProps = {
    children: React.ReactNode;
    disableAdSlots?: boolean;
};

const MainLayoutMobile: React.FC<MainLayoutMobileProps> = ({
    children,
    disableAdSlots = false
}) => (
    <>
        <Head>
            <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0" />
            <meta charSet="UTF-8" />
        </Head>
        {!disableAdSlots && (
            <AdSlotSSR name={SLOT_SPONSORING_TOP} className="creation-topbar" />
        )}
        <HeaderMobile />
        <MainLayout>
            {children}
        </MainLayout>
        <Container className="screening-bg screening-bg--footer">
            <FooterMobile />
        </Container>
        {!disableAdSlots && (
            <AdSlot name={SLOT_SCROLLER} className="creation-bottom" />
        )}
    </>
);

export default MainLayoutMobile;
